import AssetExportForWpp from './AssetExportForWpp';

class WppExportResult {
  totalRecords = 0;
  
  items = null;

  sizeInMb = 0.0;

  constructor(data) {
    this.totalRecords = data.totalRecords;
    this.items = AssetExportForWpp.fromObjects(data.items);
    this.sizeInMb = data.sizeInMb;
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }

    return new WppExportResult(data);
  }
}

export default WppExportResult;
